import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class WindowScrollService {
	public scrollToElement(config: { elementId: string }) {
		const elementToScroll = document.getElementById(config.elementId);
		if (elementToScroll) {
			elementToScroll.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
		}
	}
}
